module.exports = __webpack_public_path__ + "img/homeicon.4e436bd1.svg";